import { useState } from "react";

import { useAppDispatch } from "../redux";
import {
	addDownloadJob,
	updateDownloadJobStatus,
	useCreateDownloadReportJobMutation
} from "../redux/reducers/downloadJobs.reducer";
import { showFeedbackNotification } from "../redux/reducers/feedbackNotification.reducer";
import downloadServices from "../redux/services/download.services";
import { ICreateReportJobRequestData } from "../types";

export function useDownloadJob() {
	const dispatch = useAppDispatch();

	const [isLoading, setIsLoading] = useState<boolean>(false);

	// APIS
	// CREATE DOWNLOAD REPORT JOB
	const [createDownloadReportJob] = useCreateDownloadReportJobMutation();

	function handleDownloadReport(jobID: string) {
		downloadServices
			.handleDownloadReport(jobID)
			.catch((error) => {
				dispatch(
					showFeedbackNotification({
						message: "data" in error && error.data ? String(error.data) : "Download failed",
						severity: "error"
					})
				);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}

	function startDownload(options: ICreateReportJobRequestData) {
		setIsLoading(true);

		createDownloadReportJob(options)
			.unwrap()
			.then((response) => {
				if (response.file_exists) {
					handleDownloadReport(response.job_id);
					return;
				}

				// Add job to store with report type
				dispatch(
					addDownloadJob({
						response,
						reportType: options.report_type
					})
				);

				// Set status to pending - useDownloadJobsManager will handle the SSE connection
				dispatch(
					updateDownloadJobStatus({
						jobId: response.job_id,
						status: "pending",
						message: "Starting download..."
					})
				);

				setIsLoading(false);
			})
			.catch((error) => {
				dispatch(
					showFeedbackNotification({
						message: "data" in error && error.data ? String(error.data) : "Something went wrong",
						severity: "error"
					})
				);

				setIsLoading(false);
			});
	}

	return {
		isLoading,
		startDownload
	};
}
